export const isCheckBeforeTargetDate = (displayDateTime: string): boolean => {
  const nowDate = new Date();
  nowDate.setDate(nowDate.getDate() - 7);
  const displayDate = new Date(displayDateTime);
  return nowDate >= displayDate;
};
